import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import { ThemeProvider } from "@emotion/react"

import theme from "../../theme"
import Header from "../header"
import Footer from "../footer"
import MobileNav from "../mobilenav"
import ExternalScripts from "../externalscripts"

import { icons } from "../../data/socialmediaicons"

import { connect } from "react-redux"
import { addBrandedContent, hideModal } from "../../actions"

import SlidingPane from "react-sliding-pane"
import "../styled/sliderpanel.css"

import { HeaderWrapper } from "../styled"

import styled from "@emotion/styled"

import SubscriptionModal from "../subscriptionmodal"

const query = graphql`
  query SiteQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
    siteSearchIndex {
      index
    }
  }
`

const Main = styled.main`
  padding-top: 64px;
  @media (min-width: 768px) {
    padding-top: 0;
    &.sticky-main {
      padding-top: 52px;
    }
  }
`

const RenderLayout = ({
  children,
  data,
  addBrandedContent,
  modalVisible,
  modalMessage,
  hideModal,
}) => {
  const [navOpen, setNavOpen] = useState(false)
  const [stickyHeader, setStickyHeader] = useState(false)
  const [mouseDown, setMouseDown] = useState(false)

  /*
   * mouseDown is used to removed outline style for focused
   * elements on mouse click but show for tab navigation
   */
  useEffect(() => {
    document.addEventListener("mousedown", (event) => {
      setMouseDown(true)
    })
    document.addEventListener("keydown", (event) => {
      setMouseDown(false)
    })
  }, [])

  const outerClick = () => {
    toggleMobileNav()
  }

  const toggleMobileNav = () => {
    let closing = navOpen
    setNavOpen(!navOpen)
    if (closing) {
      disableBodyScroll(false)
      if (window.zE && window.zE.show && typeof window.zE.show === "function") {
        window.zE.show()
      }
    } else {
      disableBodyScroll(true)
      if (window.zE && window.zE.hide && typeof window.zE.hide === "function") {
        window.zE.hide()
      }
    }
  }

  const disableBodyScroll = (disabled = true) => {
    if (typeof document !== undefined) {
      if (!disabled) {
        document.body.style.overflow = ""
        document.body.classList.remove("mobilenav-open")
      } else {
        document.body.style.overflow = "hidden"
        document.body.classList.add("mobilenav-open")
      }
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <HeaderWrapper className={mouseDown ? "mousedown" : ""}>
        <Header
          navOpen={navOpen}
          toggleMobileNav={toggleMobileNav}
          setStickyHeader={setStickyHeader}
          searchIndex={data.siteSearchIndex.index}
        />
        <Main
          className={stickyHeader ? "body-wrapper sticky-main" : "body-wrapper"}
        >
          {children}
        </Main>
        <SubscriptionModal
          message={modalMessage}
          visible={modalVisible}
          hideModal={hideModal}
        />
        <SlidingPane
          className="sliding-pane"
          overlayClassName="sliding-pane-overlauy"
          isOpen={navOpen}
          onRequestClose={outerClick}
        >
          <MobileNav
            icons={icons}
            outerClick={outerClick}
            toggleMobileNav={toggleMobileNav}
          />
        </SlidingPane>
        <Footer />
        <ExternalScripts />
      </HeaderWrapper>
    </ThemeProvider>
  )
}

const Layout = ({
  children,
  addBrandedContent,
  modalVisible,
  modalMessage,
  hideModal,
}) => {
  return (
    <>
      <StaticQuery
        query={`${query}`}
        render={(data) => (
          <RenderLayout
            modalVisible={modalVisible}
            hideModal={hideModal}
            modalMessage={modalMessage}
            data={data}
            children={children}
            addBrandedContent={addBrandedContent}
          />
        )}
      />
    </>
  )
}

RenderLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

const mapStateToProps = (state) => {
  return {
    modalVisible: state.modalVisibleReducer.modalVisible,
    modalMessage: state.modalVisibleReducer.modalMessage,
  }
}

export default connect(mapStateToProps, { addBrandedContent, hideModal })(
  Layout
)
